import script from "./ConnectWalletModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectWalletModal.vue?vue&type=script&setup=true&lang=js"

import "./ConnectWalletModal.vue?vue&type=style&index=0&id=7dd9bf10&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd9bf10"]])

export default __exports__